/**
 * `/alta` — una sola dirección que hace lo correcto según quién entre.
 *
 * **Sin sesión muestra el registro. Con sesión, la configuración.**
 *
 * Antes `/alta` estaba detrás de `RequireAuth` y no existía pantalla para crear
 * la cuenta, así que quien entraba rebotaba al login sin forma de conseguir
 * una. El product owner lo reportó como «la página de alta me regresa a la
 * vista de login»: no era el guardia, faltaba la puerta.
 *
 * Que sea UNA sola dirección importa porque es el enlace que se comparte. Con
 * dos —`/registro` y `/alta`— la mitad de la gente llega a la equivocada.
 *
 * ⚠️ **Esta ruta va FUERA de `RequireAuth`.** Meterla adentro por simetría con
 * el resto del panel reintroduce el bug entero.
 */

import { useAuth } from '../../hooks/useAuth.tsx';
import { PaginaDeRegistro } from './PaginaDeRegistro';
import { PaginaDelAlta } from './PaginaDelAlta';
import { ShellDelAlta } from './ShellDelAlta';

export function PuertaDelAlta() {
  const { token } = useAuth();
  // El shell va en las dos caras: quien se está registrando también tiene que
  // ver que está en Tibo, y quien ya entró necesita poder cerrar sesión.
  return <ShellDelAlta>{token ? <PaginaDelAlta /> : <PaginaDeRegistro />}</ShellDelAlta>;
}
